var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.user.hasRoles.includes("Archived Teacher")
        ? _c("v-banner", { attrs: { color: "soli-status-red" } }, [
            _c("div", { staticClass: "white--text flex justify-center" }, [
              _vm._v("\n            This teacher has been archived\n        "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        {
          class: [
            _vm.$vuetify.breakpoint.mdAndUp ? "soli-round" : "mobile-scroll",
          ],
          staticStyle: { margin: "0px" },
          attrs: { flat: _vm.$vuetify.breakpoint.smAndDown },
        },
        [
          _c(
            "v-toolbar",
            {
              directives: [
                {
                  name: "scroll",
                  rawName: "v-scroll",
                  value: _vm.handleScroll,
                  expression: "handleScroll",
                },
              ],
              class: [_vm.scrolled ? "avail-toolbar" : false],
              staticStyle: { top: "0px" },
              attrs: { flat: "" },
            },
            [
              _c(
                "v-col",
                { staticClass: "col-12 col-sm-2 col-md-4" },
                [
                  _vm.$vuetify.breakpoint.smAndUp
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "stack-btn",
                          attrs: { color: "soli-grey", icon: "" },
                          on: { click: _vm.setToday },
                        },
                        [
                          _c("v-icon", [_vm._v("today")]),
                          _c("small", { staticStyle: { "font-size": "8px" } }, [
                            _vm._v(" Today "),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$vuetify.breakpoint.xs
                    ? _c(
                        "v-row",
                        {
                          staticClass: "align-center justify-around",
                          staticStyle: { height: "72px" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                fab: "",
                                text: "",
                                small: "",
                                color: "grey darken-2",
                              },
                              on: { click: _vm.prev },
                            },
                            [
                              _c("v-icon", { attrs: { medium: "" } }, [
                                _vm._v(" chevron_left "),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-bottom-sheet",
                            {
                              attrs: {
                                "close-on-content-click": true,
                                "min-width": "290px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            {
                                              staticClass: "mx-3 font-bold",
                                              staticStyle: {
                                                cursor: "pointer",
                                                color: "#4b5563",
                                              },
                                            },
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.globalMomentDateShort(
                                                    new Date(_vm.title)
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1304891534
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("v-date-picker", {
                                attrs: { "full-width": "" },
                                on: { "click:date": _vm.jumpDate },
                                model: {
                                  value: _vm.getTitleDate,
                                  callback: function ($$v) {
                                    _vm.getTitleDate = $$v
                                  },
                                  expression: "getTitleDate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                fab: "",
                                text: "",
                                small: "",
                                color: "grey darken-2",
                              },
                              on: { click: _vm.next },
                            },
                            [
                              _c("v-icon", { attrs: { medium: "" } }, [
                                _vm._v(" chevron_right "),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$vuetify.breakpoint.xs
                ? _c(
                    "v-col",
                    {
                      staticClass:
                        "col-12 col-sm-8 col-md-4 justify-center align-center d-flex",
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            fab: "",
                            text: "",
                            small: "",
                            color: "grey darken-2",
                          },
                          on: { click: _vm.prev },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v(" chevron_left "),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-content-click": true,
                            "nudge-left": 62.5,
                            transition: "scale-transition",
                            "min-width": "290px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-toolbar-title",
                                      _vm._g(
                                        {
                                          staticClass: "mx-10",
                                          staticStyle: {
                                            cursor: "pointer",
                                            color: "#4b5563",
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.title) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            163580790
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("v-date-picker", {
                            on: { "click:date": _vm.jumpDate },
                            model: {
                              value: _vm.getTitleDate,
                              callback: function ($$v) {
                                _vm.getTitleDate = $$v
                              },
                              expression: "getTitleDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            fab: "",
                            text: "",
                            small: "",
                            color: "grey darken-2",
                          },
                          on: { click: _vm.next },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v(" chevron_right "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-col", { staticClass: "col-12 col-sm-2 col-md-4" }, [
                !_vm.$vuetify.breakpoint.xs
                  ? _c("div", {
                      staticClass: "soli-toolbar mt-0 pr-3 pl-1 float-right",
                      attrs: { align: "center", justify: "space-around" },
                    })
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.clickData
            ? _c("ManageAvail", {
                attrs: {
                  errors: _vm.errors,
                  type: _vm.eventType,
                  teacher: _vm.user,
                  avail: _vm.clickData,
                  avails: _vm.availabilities,
                  calendarDate: _vm.getCalendarDate,
                },
                on: {
                  reset: function ($event) {
                    return _vm.reset($event)
                  },
                  success: function ($event) {
                    return _vm.$emit("success")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.requestAssignment !== null
            ? _c("SoliChoice", {
                attrs: {
                  title: "Uh-oh",
                  subtitle:
                    "Unable to move availability with in-studio assignments or lessons.",
                  button1: "Okay",
                },
                on: {
                  option1: function ($event) {
                    _vm.requestAssignment = null
                  },
                  reset: function ($event) {
                    _vm.requestAssignment = null
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("FullCalendar", {
            ref: "fullCalendar",
            staticClass: "fc-teacher-avail",
            attrs: { id: "fc-teacher-avail", options: _vm.calendarOptions },
            scopedSlots: _vm._u([
              {
                key: "eventContent",
                fn: function (arg) {
                  return [
                    _c("div", { staticClass: "pt-1 pl-2" }, [
                      arg.timeText
                        ? _c(
                            "b",
                            { class: arg.isMirror ? "soli-grey" : null },
                            [
                              _vm._v(
                                _vm._s(arg.timeText) + "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      arg.event.extendedProps.recurrence_id
                        ? _c(
                            "div",
                            { staticClass: "flex align-center mt-1" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  attrs: { "x-small": "", color: "white" },
                                },
                                [_vm._v("repeat")]
                              ),
                              _vm._v(" "),
                              _c("small", [_vm._v(" Weekly ")]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      arg.event.extendedProps.recurrence_end &&
                      !arg.event.extendedProps.removed_from_series
                        ? _c(
                            "div",
                            { staticClass: "flex align-center mt-1" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  attrs: { "x-small": "", color: "white" },
                                },
                                [_vm._v("event_busy")]
                              ),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(
                                  _vm._s(
                                    `Until ${_vm.globalMomentDate(
                                      arg.event.extendedProps.recurrence_end
                                    )}`
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      arg.event.extendedProps.removed_from_series
                        ? _c(
                            "div",
                            { staticClass: "flex align-center mt-1" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  attrs: { "x-small": "", color: "white" },
                                },
                                [_vm._v("event_busy")]
                              ),
                              _vm._v(" "),
                              _c("small", [_vm._v("Removed from series")]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex align-center mt-1" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-1",
                              attrs: { "x-small": "", color: "white" },
                            },
                            [_vm._v("people")]
                          ),
                          _vm._v(" "),
                          arg.event.extendedProps.lessons
                            ? _c("small", [
                                _vm._v(
                                  _vm._s(
                                    `${
                                      arg.event.extendedProps.lessons.filter(
                                        (e) => !e.cancelled
                                      ).length
                                    } lesson(s)`
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex align-center mt-1" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-1",
                              attrs: { "x-small": "", color: "white" },
                            },
                            [_vm._v("storefront")]
                          ),
                          _vm._v(" "),
                          arg.event.extendedProps.assignments?.length
                            ? _c("small", [
                                _vm._v(
                                  _vm._s(
                                    `${arg.event.extendedProps.assignments
                                      .map((e) => e.location.name)
                                      .filter(
                                        (value, index, self) =>
                                          self.indexOf(value) === index
                                      )}`
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !arg.event.extendedProps.assignments?.length
                            ? _c("small", [_vm._v("Unassigned")])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      arg.event.extendedProps.online_only
                        ? _c(
                            "div",
                            { staticClass: "flex align-center mt-1" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  attrs: { "x-small": "", color: "white" },
                                },
                                [_vm._v("videocam")]
                              ),
                              _vm._v(" "),
                              _c("small", [_vm._v("Online Only")]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }